import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';

export default function ErrorMessage({ message }) {
  const { Text } = UX2.Element;
  var output = null;
  if (message) {
    output = <Text children={ message } style={{ textAlign: 'center' }} />;
  }

  return output;
}

ErrorMessage.propTypes = {
  message: PropTypes.string
};
